module.exports = __webpack_public_path__ + "img/404.05a08ac3.png";